import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { DATE_RANGES_FROM_SELECTOR, DATE_PICKER_COMPARE_TITLES, getDatePickerRangeCompare, getDatePickerUIObjectFromDateRange, momentWeekType } from "@/utils/datepicker";
import moment from "moment";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import { EVENTS, APP_PERIOD_DROPDOWN_ELEMENTS } from "@/utils/constants";
import AppDropdown from "@/components/AppDropdown.vue";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import FlexColumn from "@/components/FlexColumn.vue";
import DateValue from "@/components/tableElements/DateValue.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import PerformancePeriodTable from "@/components/market_insights/PerformancePeriodTable.vue";
import PerformanceProductTable from "@/components/market_insights/PerformanceProductTable.vue";
import MarketInsightsFilters from "@/components/MarketInsightsFilters.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import { FLOATING_COMPOUND_TABLE_STATES } from "../utils/constants";
export default {
  name: "MarketInsightsPage",
  components: {
    AppDropdown,
    AppButtonRadioGroup,
    CurrencyFilter,
    FlexColumn,
    DateValue,
    LiteTableMixin,
    PerformancePeriodTable,
    MarketInsightsFilters,
    PerformanceProductTable,
    PeriodControllers
  },
  mixins: [LiteTableMixin, DashboardV2Mixin],
  created() {
    this.originalWeekType = this.getSystemWeekType;
    this.$store.dispatch("setWeekTypeConfig", "monday");
  },
  beforeUnmount() {
    this.$store.dispatch("setWeekTypeConfig", this.originalWeekType);
    window.$bus.off(EVENTS.REFRESH_MARKET_INSIGHTS, () => this.refreshAllKpis());
  },
  async mounted() {
    this.datePickerCommitterFunction = this.marketInsightsSetProductTablePeriod;
    this.$store.dispatch("marketInsightsSetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_MARKET_INSIGHTS, () => this.refreshAllKpis());
    const renderingStart = performance.now();
    await this.initializeSellersFilter(this.marketInsightsSellersFilterSet);
    await this.refreshMarketInsightsSellersSubFilters();
    this.$store.dispatch("marketInsightsSetProductTableGroupByElements");
    //  console.log(
    //     "this.store",
    //     this.$store.state.market_insights.product_table.group_by_elements
    //   );

    window.$bus.trigger(EVENTS.FLOATING_COMPOUND_TABLE_OPEN_COLLAPSE);

    // Set the default date picker date
    this.applyPeriodForDatePicker(this.periodGroupBy);
    this.refreshAllKpis();
    const renderingEnd = performance.now();
    //  console.log(
    //   `[Perf][Market Insights Rendering]: ${(renderingEnd - renderingStart) / 1000
    //   } s`
    //   );
    window.$bus.on(EVENTS.REFRESH_MARKET_INSIGHTS_SELLERS_SUB_FILTERS, this.refreshMarketInsightsSellersSubFilters);
    window.$bus.on(EVENTS.REFRESH_MARKET_INSIGHTS_MARKETPLACES_SUB_FILTERS, this.refreshMarketInsightsMarketPlacesSubFilters);
    this.checkLocalStorageOnMarketplaceFilter = false;
  },
  data() {
    return {
      today: moment(),
      sellers: [],
      marketplaces: [],
      periodTableLoading: true,
      productTableLoading: true,
      mediatorRefreshers: {
        PERIOD_TABLE: this.refreshPeriodTable,
        PRODUCT_TABLE: this.refreshProductTable
      },
      DATE_RANGES_FROM_SELECTOR,
      checkLocalStorageOnMarketplaceFilter: true,
      FLOATING_COMPOUND_TABLE_STATES
    };
  },
  computed: {
    ...mapState({
      currentPeriod: state => state.market_insights.currentPeriod,
      periodSelectorOptions: state => state.market_insights.periodSelectorOptions,
      tabs: state => state.market_insights.tabs,
      productTable: state => state.market_insights.product_table,
      productTableGroupBy: state => state.market_insights.product_table.group_by_text,
      currentTabValue: state => state.market_insights.currentTabValue,
      floatingTableState: state => state.market_insights.product_table.state,
      currencies: state => state.market_insights.currencies,
      sellers_filter: state => state.market_insights.sellers_filter,
      marketplaces_filter: state => state.market_insights.marketplaces_filter,
      categories_filter: state => state.market_insights.categories_filter
    }),
    ...mapGetters(["marketInsightsGetPeriod", "marketInsightsGetPeriodCategory", "marketInsightsGetTab", "getSystemWeekType", "isUserInBetaAccessGroup", "marketInsightsGetPeriodOptions"]),
    currentSellerIds() {
      return this.sellers_filter.filterValues;
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.selectedValues;
    },
    period: {
      set(value) {
        this.$store.dispatch("marketInsightsSetPeriod", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      },
      get() {
        return this.marketInsightsGetPeriod();
      }
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("marketInsightsSetPeriodCategory", value);
      },
      get() {
        return this.marketInsightsGetPeriodCategory();
      }
    },
    tab: {
      async set(value) {
        this.$store.dispatch("marketInsightsSetTab", {
          tabIndex: value,
          tabValue: this.tabs[value].value
        });
      },
      get() {
        return this.marketInsightsGetTab();
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    getCurrentPeriodDate() {
      if (this.period === APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value) {
        return momentWeekType["monday"]();
      }
      return this.currentPeriod[this.period].date;
    },
    periodOptions() {
      return this.marketInsightsGetPeriodOptions;
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    }
  },
  methods: {
    ...mapMutations(["marketInsightsSellersFilterSet", "marketInsightsMarketplacesFilterSet", "marketInsightsSetProductTablePeriod"]),
    ...mapActions(["getMarketInsightsCategories"]),
    handleErrorOccured() {
      this.announceNoAccounts();
      this.periodTableLoading = false;
    },
    async refreshPeriodTable() {
      this.periodTableLoading = true;
      await this.$store.dispatch("marketInsightsFetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshMediator(refresheeList) {
      const perf = [];
      perf.push(performance.now());
      //console.log("Refreshee List", refresheeList);
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
      perf.push(performance.now());

      //console.log(`[perf][refreshMediator]: ${(perf[1] - perf[0]) / 1000} s`);
    },
    async refreshProductTable() {
      this.productTableLoading = true;
      let previousPeriodCategory = this.periodCategory;
      this.periodCategory = "prev_period";
      const groupByFetch = this.productTable[this.currentTabValue].data[this.productTableGroupBy]?.fetch;
      if (groupByFetch) await this.$store.dispatch(groupByFetch);
      this.periodCategory = previousPeriodCategory;
      this.productTableLoading = false;
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    // Clear any evolution row selection without refetching.
    restoreEvolutionTable() {
      this.$store.commit("marketInsightsDeselectPeriodTable");
    },
    handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("marketInsightsSetProductTableSort", {
        sort,
        direction
      });
      this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleSetPeriodTable(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    refreshAllKpis() {
      this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async refreshMarketInsightsSellersSubFilters() {
      await this.initializeMarketplacesFilter(this.marketInsightsMarketplacesFilterSet, this.checkLocalStorageOnMarketplaceFilter);
      this.marketplaces_filter._key = "marketplace_id";
      await this.refreshMarketInsightsMarketPlacesSubFilters();
    },
    async refreshMarketInsightsMarketPlacesSubFilters() {
      const categories_result = await this.getMarketInsightsCategories({
        seller_id: this.currentSellerIds,
        marketplaces: this.currentMarketplaceIds
      });
      this.categories_filter.initialize({
        list: categories_result,
        selected: [],
        key: "id",
        name: "category_filter"
      });
    }
  }
};